import type { FC } from 'react';
import { useEffect } from 'react';
import styled from 'styled-components';

import { ActivityCenterSkeleton } from '@xing-com/crate-activity-center-skeleton';
import { useLocation } from '@xing-com/crate-core-router';
import { Helmet } from '@xing-com/crate-helmet';
import { XingletLoader } from '@xing-com/crate-xinglet';
import { useActivityCenter, useLoginState } from '@xing-com/hub';

// test style to simulate popup container
const StyledOuterContainer = styled.div`
  max-width: 426px;
  margin: 0 auto;
`;

export const ActivityCenterCheckoutPage: FC = () => {
  const isLoggedIn = useLoginState() === 'LOGGED_IN';
  const { isActivityCenterVisible } = useActivityCenter();

  useEffect(() => {
    if (isLoggedIn) {
      window.location.href = '/';
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (isActivityCenterVisible) {
      window.location.reload();
    }
  }, [isActivityCenterVisible]);

  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const destUrl = urlParams.get('dest_url');

  if (isLoggedIn) {
    return null;
  }

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <StyledOuterContainer data-qa="activity-center-checkout-page-container">
        <XingletLoader
          name="@xing-com/crate-activity-center-component"
          origin="checkout_page"
          fallback={<ActivityCenterSkeleton />}
          customQueryParams={{
            sc_o: 'activitycenter_sign_up_button_click',
            propActionOrigin: 'activitycenter_page',
            dest_url: destUrl,
            signup_channel: 'minireg_activitycenter_page',
          }}
        />
      </StyledOuterContainer>
    </>
  );
};
